import SequenceBase from './SequenceBase';


class CustomBase extends SequenceBase {

	constructor( json:Object ){
		super( json );	
	}
	
	set title( t:string ){
		this.set( 'title', t );	
	}
	
	set module( t:string ){
		this.set( 'module', t );	
	}

	get done():boolean {
		return this.get<boolean>( 'done' );
	}

	set done( d:boolean ){
		this.set( 'done', d );
	}
	
}

export default CustomBase;